import apiStore from '@/api/public/store';

const defaultState = () => ({
	store: [],
	loadStore: false,
	detailStore: {},
	detailStoreAddress: {},
	storePagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	kurirToko: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setStore(state, data) {
		state.store = data.data
		state.storePagination = data.pagination;
	},
	setLoadStore(state, data) {
		state.loadStore = data
	},
	setKurirToko(state, data) {
		state.kurirToko = data
	},
	setDetailStore(state, data) {
		state.detailStore = data
	},
	setStoreAddress(state, data) {
		state.detailStoreAddress = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearStore(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getStore({ commit }, params) {
		commit('setLoadStore', true);
		return new Promise((resolve) => {
			apiStore.getStore(params).then(({ data: { data } }) => {
				commit('setStore', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setStore', { data: [], pagination: {} });
			}).then(() => {
				commit('setLoadStore', false);
			});
		});
	},
	async getStoreDetail({ commit }, params) {
		commit('setLoadStore', true);
		return new Promise((resolve, reject) => {
			apiStore.getStoreDetail(params).then(({ data: { data } }) => {
				commit('setDetailStore', data.results);
				resolve(true);
			}).catch(() => {
				reject(true)
				commit('setDetailStore', {});
			}).then(() => {
				commit('setLoadStore', false);
			});
		});
	},
	async getStoreByInternal({ commit }, params) {
		commit('setLoadStore', true);
		return new Promise((resolve) => {
			apiStore.getStoreByInternal(params).then(({ data: { data } }) => {
				commit('setStore', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setStore', { data: [], pagination: {} });
			}).then(() => {
				commit('setLoadStore', false);
			});
		});
	},
	async getStoreByAddress({ commit }, params) {
		commit('setLoadStore', true);
		return new Promise((resolve) => {
			apiStore.getStoreByAddress(params).then(({ data: { data } }) => {
				commit('setStoreAddress', data.results);
				resolve(true);
			}).catch(() => {
				commit('setStoreAddress', {});
			}).then(() => {
				commit('setLoadStore', false);
			});
		});
	},
	async getKurirByToko({ commit }, params) {
		// commit('setLoadStore', true);
		return new Promise((resolve) => {
			apiStore.getKurirByToko(params).then(({ data: { data } }) => {
				commit('setKurirToko', data);
				resolve(true);
			}).catch(() => {
				commit('setKurirToko', {});
			}).then(() => {
				// commit('setLoadStore', false);
			});
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};